export enum NotificationType {
  BIRTHDAY_POINT = 'BIRTHDAY_POINT',
  INCORRECT_PURCHASES = 'INCORRECT_PURCHASES',
  USER_BLOCKED = 'USER_BLOCKED',
  ORDER_CANCEL_BY_STORE = 'ORDER_CANCELED_BY_STORE',
}
